import React from "react";
import Headline from "../components/shared/Headline";
import { Col, Flex, Row } from "antd";
import RibbonSection from "../components/shared/RibbonSection";

const bannerPath = '/iceholidays-assets/images/about_us.png';
const breadcrumbs = [
  { title: 'Home' },
  { title: 'About Us' }
] 

const AboutUsPage = React.FC = () => (
  <div id="about-us-page">
    <Headline bannerImage={bannerPath} breadcrumbs={breadcrumbs} title="“WHAT WE DO”"/>

    <div id="about-us-page_body">
      <div id="introduction">
        <Flex vertical align="center" justify="center">
          <img src="/iceholidays-assets/images/logomark.png"/>
          <h1> Welcome To The Signature Tours </h1>
        </Flex>
      </div>

      <div id="article">
        <Row gutter={40}>
          <Col span={24}>
            <img src="/iceholidays-assets/images/about_us2.png"/>
          </Col>
          <Col xs={24} sm={24} lg={12}>
            <p>The Signature Tours was born from a passion for redefining travel. We believe that journeys should be more than just trips—they should be transformative experiences, filled with moments that leave an indelible mark on the soul. Catering to discerning travelers who seek more than the ordinary, The Signature Tours crafts bespoke journeys that combine sophistication, cultural immersion, and unparalleled quality. </p>
            <p>Our story begins with a vision: to create journeys that linger in the heart long after the traveler returns home. Each itinerary we design reflects our dedication to perfection. From the charm of boutique accommodations nestled in picturesque landscapes to handpicked cultural experiences that unveil the soul of a destination, every detail is thoughtfully considered to ensure your journey is as seamless as it is extraordinary.</p>
            <p>At The Signature Tours, we embrace the philosophy of the S-Tours experience—where every moment is a masterpiece. Imagine strolling through the cobblestone streets of a quaint village, savoring the aroma of freshly baked bread as locals welcome you with warm smiles. </p>
          </Col>
          <Col xs={24} sm={24} lg={12}>
            <p>Picture yourself standing atop a majestic mountain at sunrise,the golden hues of the horizon reflecting the sense of awe within you. These are the kinds of moments we strive to create—authentic, meaningful, and unforgettable.</p>
            <p>But our commitment goes beyond premium and comfort. It’s about forging connections—with places, cultures, and people. It’s about stepping into a story, whether it’s exploring ancient ruins with a seasoned archaeologist, learning the art of wine making from a passionate vintner, or sharing laughter with a local family over a home-cooked meal.</p>
            <p>At The Signature Tours, every journey is an invitation to step out of the ordinary and into a world of wonder. We’re not just about travel; we’re about creating memories that stay with you forever. This is our promise, and this is what we call the S-Tours philosophy where we deliver S-Class Journeys, Signature Memories. Because every journey should be as unique as your signature.</p>
          </Col>
        </Row>
      </div>


    </div>
    <RibbonSection>
      <>
      <Row id="quality-policy" gutter={40} justify="center">
        <Col span={24}>
          <div className="section-header">
            <h2>Quality Policy</h2>
            <p>ICE Holidays is committed to striving towards our customer satisfaction in areas of more quality value for money of our products & services. The management and all employees are committed to the company quality policy through effort in:</p>
          </div>
        </Col>
        <Col xs={24} sm={24} lg={8}>
            <div className="items">
              <img src="/iceholidays-assets/images/innovative.png"/>
              <label>Innovative</label>
              <p>Talent team develops great products and services; Agile, innovative, and a quality conscious team of resourceful people dedicated to the best.</p>
            </div>
        </Col>
        <Col xs={24} sm={24} lg={8}>
            <div className="items">
              <img src="/iceholidays-assets/images/competitiveness.png"/>
              <label>Competitiveness</label>
              <p>Provide competitive pricing to achieve customer satisfaction.</p>
            </div>
        </Col>
        <Col xs={24} sm={24} lg={8}>
            <div className="items">
              <img src="/iceholidays-assets/images/ethical.png"/>
              <label>Ethical</label>
              <p>Precedent for an honest, fair and ethical business.</p>
            </div>
        </Col>
      </Row>

      <Row id="certificates" align="middle" justify="center" gutter={[24, 24]}>
        <Col span={24}>
          <div className="section-header">
            <h2>Our Certificates</h2>
            <p>We have acquired recognition and certificates such as:</p>
          </div>
        </Col>
        <Col xs={24} sm={24} md={12} lg={8}>
            <img src="/iceholidays-assets/images/certificate1.png"/>
        </Col>
        <Col xs={24} sm={24} md={12} lg={8}>
            <img src="/iceholidays-assets/images/certificate2.png"/>
        </Col>
      </Row>
      </>
    </RibbonSection>
  </div>
);

export default AboutUsPage;